import { IAxiosInstance } from "clients/AbstractApiClient/AbstractApiClient";

export const getContractorPaymentGroupById =
  (axios: IAxiosInstance) => async (groupId: string) => {
    const response = await axios.noRetry.get(
      `/contractor-payment-group/${groupId}`
    );
    return response.data.data;
  };
